import React from "react";
import { RotateCcw, AlertTriangle } from "lucide-react";

/** WidgetErrorState — per-module error with retry, keeps the rest of the dashboard alive. */
export default function WidgetErrorState({ message = "Impossible de charger ce module.", onRetry, testid }) {
  return (
    <div className="rounded-2xl border border-border bg-card p-6 flex flex-col items-center justify-center gap-2.5 min-h-[160px]" data-testid={testid || "widget-error"}>
      <AlertTriangle className="h-5 w-5 text-warning" />
      <div className="text-xs text-muted-foreground text-center">{message}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 h-9 px-4 rounded-lg border border-border text-xs font-medium hover:bg-secondary/60 transition-colors"
          data-testid={`${testid || "widget-error"}-retry`}
        >
          <RotateCcw className="h-3 w-3" /> Réessayer
        </button>
      )}
    </div>
  );
}
